<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Denounced } from "../../../../Model/Denounced";
  import type { DenouncedTraffic } from "../../../../Model/DenouncedTraffic";
  import type { Third } from "../../../../Model/Third";
  import { denouncedService, denouncedTrafficService } from "../../../../services";
  import DenouncedInfoForm from "../../DenouncedInfoForm.svelte";

  export let denouncedThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, denouncedThird)

  let size = "lg";
  let denounced: Denounced;
  let denouncedTraffic: DenouncedTraffic;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, denouncedThird){
    if (diligenceId && denouncedThird) {
      denounced = await denouncedService.findOne(denouncedThird.id, diligenceId)
      if (denounced) {
        denouncedTraffic = await denouncedTrafficService.findOne(denouncedThird.id, denounced.diligenceNumber);
      }
    }
  }

  async function saveDenouncedTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    denounced.denouncedThirId = third.id;
    denouncedTraffic.denouncedThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      denouncedService.saveDenounced(denounced),
      denouncedTrafficService.saveDenouncedTraffic(denouncedTraffic)
    ])

    dispatch('saveDenounced');
  }

</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      <TabPane tabId="Datos" tab="Datos" active>
        {#if denounced}
          <DenouncedInfoForm denounced={denounced} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
      {#if denouncedTraffic}
        <TabPane tabId="dataInfo2" tab="Inf.Médico">
          <div class="row mt-2">
            <div class="col-12 mb-2">
              <Label>Historial Médico</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={denouncedTraffic.medicalHistory}
              />
            </div>
            <div class="col-12 mb-2">
              <Label>Parte Facultativo</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={denouncedTraffic.optionalPart}
              />
            </div>
          </div>
        </TabPane>
      {/if}

    </TabContent>

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveDenouncedTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

